import { render, staticRenderFns } from "./RegisterFormForm.vue?vue&type=template&id=ba51face&scoped=true&"
import script from "./RegisterFormForm.vue?vue&type=script&lang=ts&"
export * from "./RegisterFormForm.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterFormForm.vue?vue&type=style&index=0&id=ba51face&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba51face",
  null
  
)

export default component.exports